import { render, staticRenderFns } from "./PlaylistTabSongs.vue?vue&type=template&id=2ef07550&"
import script from "./PlaylistTabSongs.vue?vue&type=script&lang=js&"
export * from "./PlaylistTabSongs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports